import { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert2";
import emailLogo from "../../../Assets/emailLogo.svg";
import loginlogo from "../../../Assets/loginlogo.svg";
import { forgotPassword } from "../../../services/api";

import style from "../Login/login.module.css";
export const Forgot = ({ profile }) => {
  const [formData, setFormData] = useState({
    email: "",
  });
  const changeHandler = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const submitHandler = async () => {
    if (!formData.email) alert("please enter email");
    else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)
    ) {
      swal.fire({
        icon: "warning",
        text: "Please Enter Valid Email",
        timer: 1300,
      });
      return;
    }
    try {
      const { data } = await forgotPassword({
        email: formData.email,
        profile: profile,
      });
      swal.fire({
        icon: "success",
        title: "Reset Password Link Sent to Your Email Address, Please Check",
        timer: 2000,
      });
      setInterval(() => {
        window.location.href = window.location.pathname.replace(
          "/forgot-password",
          ""
        );
      }, 2000);
    } catch (e) {
      if (e.response.data.message) {
        swal.fire({
          icon: "error",
          title: e.response.data.message,
          timer: 1300,
        });
      }
    }
  };
  return (
    <main className={style.login}>
      <div className={style.loginWrapper}>
        <div className={style.leftContainer}></div>
        <div className={style.rightContainer}>
          <div className={style.headingContainer}>
            <img src={loginlogo} alt="" />
            <h2>Welcome Back</h2>
          </div>
          <form className={style.loginForm}>
            <div className={style.inputField}>
              <div className={style.inputPrefix}>
                <img src={emailLogo} alt="" />
              </div>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={changeHandler}
                placeholder="Email address"
                autoComplete="off"
              />
            </div>

            <button type="button" onClick={submitHandler}>
              Reset
            </button>
            {/* sign in btn */}
          </form>
        </div>
      </div>
    </main>
  );
};
